/* eslint-disable camelcase */
import { useMutation } from '@tanstack/react-query'
import { aquaApi } from '../../../../api/aquaApi'
import { paths } from '../../../../api/pathsApi'
import { handleAxiosCodeError, handleAxiosError } from '../../../../helpers/handleAxiosError'
import { AxiosError } from 'axios'
import { useContext } from 'react'
import { formatDateForSend } from '../../helpers'
import { CaseBody, CaseRespose } from '../types'
import { DataForm } from '../../../../context/Necropsy/types'
import { AuthContext } from '../../../../context/Auth/AuthContext'

interface Args {
  onSuccess: (data: CaseRespose[]) => void
  onError: (error: string, body: CaseBody[]) => void
}

const saveData = async (caseData: CaseBody) => {
  const { data } = await aquaApi.post<CaseRespose>(`${paths().HEALT.CREATE_CASE}`, caseData)
  return data
}
export const useCaseSave = ({ onError, onSuccess }: Args) => {
  const { user } = useContext(AuthContext)

  const { data, error, isPending, mutate, isSuccess } = useMutation({
    mutationFn: async (requests: CaseBody[]) => {
      const results = await Promise.all(requests.map(saveData))
      return results
    },
    onSuccess(data) {
      onSuccess(data)
    },
    onError: (error: AxiosError, body) => {
      onError(JSON.stringify(error), body)
    },
  })

  const handleSendData = (values: DataForm[]) => {
    const caseBody: CaseBody[] = values
      .filter((item) => item.stateForm !== 'sent')
      .map((item) => ({
        creado_por: user.userId!,
        fecha: formatDateForSend(`${item.date!} ${item.time}:00`),
        id_jaula: item.cageId!,
        numero_caso: item.formId!,
        observacion: item.comments!,
      }))

    console.log({ caseBody })
    mutate(caseBody)
  }

  return {
    handleSendData,
    data,
    isLoading: isPending,
    isSuccess,
    msgError: handleAxiosError(error as AxiosError),
    codeError: handleAxiosCodeError(error as AxiosError),
  }
}
